import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CallbackPage_content" }
const _hoisted_2 = {
  key: 0,
  class: "CallbackPage_maintenance"
}
const _hoisted_3 = {
  key: 1,
  class: "CallbackPage_loginPanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "CallbackPage" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "lds-heart" }, [
          _createElementVNode("div")
        ], -1)),
        (_ctx.isMaintenance)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Park.it is under maintenance", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("we'll come back soon...", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isLoginPanelVisible && !_ctx.isMaintenance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Logging in takes too long?", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("p", null, "Try repeating the process with following steps:", -1)),
              _createElementVNode("p", null, [
                _cache[5] || (_cache[5] = _createTextVNode("1. Logout from previous session: ", -1)),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSoftLogoutClick && _ctx.handleSoftLogoutClick(...args)))
                }, " Soft logout "),
                _cache[6] || (_cache[6] = _createTextVNode(" or ", -1)),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleForceLogoutClick && _ctx.handleForceLogoutClick(...args)))
                }, " Force logout ")
              ]),
              _createElementVNode("p", null, [
                _cache[7] || (_cache[7] = _createTextVNode("2. Login to a new session: ", -1)),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
                }, " Login "),
                _cache[8] || (_cache[8] = _createTextVNode(" or back to ", -1)),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleHomeClick && _ctx.handleHomeClick(...args)))
                }, " Home Screen ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}